<span>
  <img src="assets/images/icons/{{icon}}.svg"
       [class.cursor-pointer]="cursorPointer"
       [ngStyle]="{'max-width.px': size, 'max-height.px': size}"
       [ngbTooltip]="tooltip"
       [openDelay]="300"
       [autoClose]="true"
       placement="top">
</span>
